module.exports = __webpack_public_path__ + "b1b6fd2cebd8c9a050b9e445673eb950.png";